module.exports = __webpack_public_path__ + "static/media/google-play-logo.c0f63918.png";